import { render } from "./APageHeader.vue?vue&type=template&id=e0b6daba"
import script from "./APageHeader.vue?vue&type=script&lang=js"
export * from "./APageHeader.vue?vue&type=script&lang=js"

import "./APageHeader.vue?vue&type=style&index=0&id=e0b6daba&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__